export default __webpack_public_path__ + "static/media/FUEL-BNB.767ec753.svg";